import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { TranslateModule } from '@ngx-translate/core';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MaterialFormComponent } from './material-form.component';
import { MatIconModule } from '@angular/material/icon';
import { InputWithSelectionListModule } from '../../input-with-selection-list/input-with-selection-list.module';
import { ADMIA_DATE_FORMATS } from '../../../core/configs/angular-material.configs';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    TranslateModule,
    MatInputModule,
    MatAutocompleteModule,
    MatIconModule,
    InputWithSelectionListModule,
  ],
  exports: [MaterialFormComponent],
  declarations: [MaterialFormComponent],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    { provide: MAT_DATE_FORMATS, useValue: ADMIA_DATE_FORMATS },
  ],
})
export class MaterialFormModule {}
